module.exports = __webpack_public_path__ + "img/dinersclub.ecd9dc4.png";